import { apiRequest, ApiResponse } from '../request'
import {
    Integration,
    CreateIntegrationDto,
    UpdateIntegrationDto,
} from '../common/interfaces/integration.interface'

export async function getIntegrations(
    paramsOrCompanyId?: number | { companyId?: number; page?: number; limit?: number; search?: string },
): Promise<ApiResponse<Integration[]>> {
    const params: any =
        typeof paramsOrCompanyId === 'number'
            ? { companyId: paramsOrCompanyId }
            : paramsOrCompanyId ?? {}
    return apiRequest<Integration[]>('integrations', { params })
}

export async function getIntegrationById(
    id: number
): Promise<ApiResponse<Integration>> {
    return apiRequest<Integration>(`integrations/${id}`, {})
}

export async function createIntegration(
    data: CreateIntegrationDto
): Promise<ApiResponse<Integration>> {
    return apiRequest<Integration>('integrations', { data }, 'post')
}

export async function updateIntegration(
    id: number,
    data: UpdateIntegrationDto
): Promise<ApiResponse<Integration>> {
    return apiRequest<Integration>(`integrations/${id}`, { data }, 'patch')
}

export async function deleteIntegration(
    id: number
): Promise<ApiResponse<void>> {
    return apiRequest<void>(`integrations/${id}`, {}, 'delete')
}

